import { MenuItemType } from '@nx-frontend/shared/types';

export function getNodeNameByType(type: MenuItemType) {
  if (type === MenuItemType.FOLDERS || type === MenuItemType.NOTES_FOLDER || type === MenuItemType.PORTAL_SECTION) {
    return 'folder';
  } else if (type === MenuItemType.PORTAL_PROCESS) {
    return 'process';
  } else if (type === MenuItemType.LINK) {
    return 'link';
  } else {
    return 'page';
  }
}
